import { atom } from 'jotai'
import type { ChatSession } from './types'
import type { Classroom } from '../api/backend'
import { loadTheme } from '../lib/storage'

const isClient = typeof window !== 'undefined'

// Core atoms — SSR-safe initialization
// Sessions start empty; useSessions hook fetches from backend API on mount
export const sessionsAtom = atom<ChatSession[]>([])
export const classroomsAtom = atom<Classroom[]>([])
// URL is the source of truth for currentSessionId; useChatRouteSync sets it on mount
export const currentSessionIdAtom = atom<string | null>(null)
export const currentClassIdAtom = atom<string | null>(null)
export const isStreamingAtom = atom<boolean>(false)
/** True while the initial session list + history are being fetched */
export const isSessionsLoadingAtom = atom<boolean>(true)
export const sidebarOpenAtom = atom<boolean>(true)
export const historyResetSessionIdsAtom = atom<Set<string>>(new Set<string>())
export const isDarkAtom = atom<boolean>(
  isClient
    ? (loadTheme() ?? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')) === 'dark'
    : false
)

// Derived atoms
export const currentSessionAtom = atom((get) => {
  const sessions = get(sessionsAtom)
  const id = get(currentSessionIdAtom)
  return sessions.find((s) => s.id === id) ?? null
})

export const currentClassroomAtom = atom((get) => {
  const classrooms = get(classroomsAtom)
  const classId = get(currentClassIdAtom)
  return classrooms.find((item) => item.id === classId) ?? null
})

export const currentMessagesAtom = atom((get) => {
  const session = get(currentSessionAtom)
  return session?.messages ?? []
})

export const currentHasMoreAtom = atom((get) => {
  const session = get(currentSessionAtom)
  return session?.hasMore ?? false
})
